export const isClearResponse = (message) => {
    return message.error === null && typeof message.id === 'number';
};
//# sourceMappingURL=clear-response.js.map